import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexTypography',
  setup(__props) {

const HeadingsSeaction = defineAsyncComponent(() => import("@/components/theme/uikits/typography/HeadingsSeaction.vue"))
const ColoredHeadings = defineAsyncComponent(() => import("@/components/theme/uikits/typography/ColoredHeadings.vue"))
const FontWeight = defineAsyncComponent(() => import("@/components/theme/uikits/typography/FontWeight.vue"))
const ListingTypography = defineAsyncComponent(() => import("@/components/theme/uikits/typography/ListingTypography.vue"))
const DisplayHeadings = defineAsyncComponent(() => import("@/components/theme/uikits/typography/DisplayHeadings.vue"))
const TextElements = defineAsyncComponent(() => import("@/components/theme/uikits/typography/TextElements.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Typography",
      title: "Typography"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(HeadingsSeaction)),
        _createVNode(_unref(ColoredHeadings)),
        _createVNode(_unref(FontWeight)),
        _createVNode(_unref(ListingTypography)),
        _createVNode(_unref(DisplayHeadings)),
        _createVNode(_unref(TextElements))
      ])
    ])
  ], 64))
}
}

})